@if (cardInfo(); as cardInfo) {
  <div>
    <mat-card class="bottom-card">
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (showAvatar && isCampaign()) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              icon="campaign"
              backgroundColor="var(--primary-background-color)"
              textColor="var(--tertiary-text-color)"
            ></glxy-avatar>
          </div>
        } @else if (showAvatar && !isCampaign()) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              icon="mail"
              backgroundColor="var(--primary-background-color)"
              textColor="var(--tertiary-text-color)"
            ></glxy-avatar>
          </div>
        }
        <mat-card-title>
          @if (headerText(); as headerText) {
            <span class="title">
              {{ headerText }}
              @if (cardInfo?.emailStatusReason) {
                <mat-icon
                  [glxyTooltip]="cardInfo.emailStatusReason"
                  [tooltipPositions]="[PopoverPositions.Right, PopoverPositions.Bottom, PopoverPositions.Top]"
                  class="warning-icon"
                  >
                  warning
                </mat-icon>
              }
            </span>
          } @else {
            <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
          }
        </mat-card-title>
        <mat-card-subtitle>
          @if (cardInfo.effectiveDate !== null) {
            <p class="effective-date">
              {{ cardInfo.effectiveDate | date: dateFormat }}
            </p>
          }
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
        @if (isCampaign()) {
          <span class="campaign-display">
            <span class="bolded">{{ cardInfo.emailSubject }}</span>
            {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
          </span>
          @if (!isDeletedCampaign()) {
            <span class="campaign-display bolded">
              <a href="{{ campaignLink() }}" target="_blank">{{ campaignName() }}</a>
            </span>
          } @else {
            <span class="campaign-display">
              {{ 'CAMPAIGNS.DELETED_CAMPAIGN' | translate }}
            </span>
          }
          @if (relatedActivities().length > 0) {
            <div class="show-activities" (click)="showRelatedActivities.set(!showRelatedActivities())">
              @if (showRelatedActivities()) {
                <mat-icon>unfold_less</mat-icon>
                {{ 'ACTIVITY.HIDE_RELATED_ACTIVITIES' | translate }}
              } @else {
                <mat-icon>unfold_more</mat-icon>
                {{ 'ACTIVITY.SHOW_RELATED_ACTIVITIES' | translate }}
              }
            </div>
            @if (showRelatedActivities()) {
              @for (activity of cardInfo.relatedActivities; track activity; let last = $last) {
                <div class="campaign-activity-card" [ngClass]="{ 'last-activity-card': last }">
                  <mat-card class="campaign-inner-card">
                    <mat-card-header [style.margin-left]="-(INNER_AVATAR_WIDTH / 2).toString() + 'px'">
                      @if (showAvatar) {
                        <div matCardAvatar>
                          <glxy-avatar
                            [width]="INNER_AVATAR_WIDTH"
                            icon="circle"
                            backgroundColor="var(--primary-background-color)"
                            textColor="var(--tertiary-text-color)"
                          ></glxy-avatar>
                        </div>
                      }
                      @if (activity.emailStatus) {
                        <mat-card-title>
                          <span class="title">
                            {{ activity.emailStatus }}&nbsp;
                            @if (activity.emailStatusReason) {
                              <mat-icon
                                [glxyTooltip]="activity.emailStatusReason"
                              [tooltipPositions]="[
                                PopoverPositions.Right,
                                PopoverPositions.Bottom,
                                PopoverPositions.Top,
                              ]"
                                class="warning-icon"
                                >
                                warning
                              </mat-icon>
                            }
                          </span>
                        </mat-card-title>
                      }
                      @if (activity.effectiveDate) {
                        <mat-card-subtitle>
                          <p class="effective-date">
                            {{ activity.effectiveDate | date: dateFormat }}
                          </p>
                        </mat-card-subtitle>
                      }
                    </mat-card-header>
                  </mat-card>
                </div>
              }
            }
          }
        } @else if (isYeswareTrackedEmail() || isYeswareCampaignEmail()) {
          <span class="campaign-display">
            <span class="bolded">{{ cardInfo.emailSubject }}</span>
            @if (cardInfo.campaignName) {
              {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
              {{ cardInfo.campaignName }}
            }
          </span>
          @if (cardInfo.emailBody) {
            <mat-card appearance="outlined" class="inner-card">
              <mat-card-content class="content" [style.margin-left]="-(AVATAR_WIDTH - 36).toString() + 'px'">
                <div>
                  <crm-collapsible-section [maxHeightPx]="300">
                    <span class="note-body" [innerHTML]="cardInfo.emailBody | iTrustThisHtml"></span>
                  </crm-collapsible-section>
                </div>
              </mat-card-content>
            </mat-card>
          }
          @if (relatedActivities().length > 0) {
            <div class="show-activities" (click)="showRelatedActivities.set(!showRelatedActivities())">
              @if (showRelatedActivities()) {
                <mat-icon>unfold_less</mat-icon>
                {{ 'ACTIVITY.HIDE_RELATED_ACTIVITIES' | translate }}
              } @else {
                <mat-icon>unfold_more</mat-icon>
                {{ 'ACTIVITY.SHOW_RELATED_ACTIVITIES' | translate }}
              }
            </div>
          }
          @if (showRelatedActivities()) {
            @for (activity of cardInfo.relatedActivities; track activity; let last = $last) {
              <div class="campaign-activity-card" [ngClass]="{ 'last-activity-card': last }">
                <mat-card class="campaign-inner-card">
                  <mat-card-header [style.margin-left]="-(INNER_AVATAR_WIDTH / 2).toString() + 'px'">
                    @if (showAvatar) {
                      <div matCardAvatar>
                        <glxy-avatar
                          [width]="INNER_AVATAR_WIDTH"
                          icon="circle"
                          backgroundColor="var(--primary-background-color)"
                          textColor="var(--tertiary-text-color)"
                        ></glxy-avatar>
                      </div>
                    }
                    @if (activity.emailStatus) {
                      <mat-card-title>
                        <span class="title">
                          {{ activity.emailStatus }}&nbsp;
                          @if (activity.emailStatusReason) {
                            <mat-icon
                              [glxyTooltip]="activity.emailStatusReason"
                              [tooltipPositions]="[PopoverPositions.Right, PopoverPositions.Bottom, PopoverPositions.Top]"
                              class="warning-icon"
                              >
                              warning
                            </mat-icon>
                          }
                        </span>
                      </mat-card-title>
                    }
                    @if (activity.effectiveDate) {
                      <mat-card-subtitle>
                        <p class="effective-date">
                          {{ activity.effectiveDate | date: dateFormat }}
                        </p>
                      </mat-card-subtitle>
                    }
                  </mat-card-header>
                </mat-card>
              </div>
            }
          }
        } @else {
          <mat-card appearance="outlined" class="inner-card">
            <mat-card-title class="mat-card-title">
              <span class="title">{{ cardInfo.emailSubject }}</span>
            </mat-card-title>
            <mat-card-content class="content" [style.margin-left]="-(AVATAR_WIDTH - 36).toString() + 'px'">
              <div class="subtitle">
                @if (cardInfo.emailDirection === 'outbound') {
                  <span>
                    @if (this.ownerName(); as ownerName) {
                      <div>
                        {{ ownerName }}
                      </div>
                    }
                    {{ 'ACTIVITY.EMAIL_TITLE.INBOUND' | translate }}
                  </span>
                }
                @for (contact of contactEmails(); track contact; let lastContact = $last) {
                  <span>
                    <a href="mailto:{{ contact }}" target="_blank" rel="noopener">{{ contact }}</a
                      >@if (!lastContact) {
                      <span>, </span>
                    }
                  </span>
                }
              </div>
              @if (cardInfo.emailBody) {
                <div>
                  <crm-collapsible-section [maxHeightPx]="300">
                    <span class="note-body" [innerHTML]="cardInfo.emailBody | iTrustThisHtml"></span>
                  </crm-collapsible-section>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
